export default __webpack_public_path__ + "static/media/grandma3.3920a340.jpg";